import publicAppsClient from "../middleware/publicAppsClient";

export const FORGOT_PASSWORD_ENDPOINT = "password/forgot";
export const RESET_PASSWORD_ENDPOINT = "password/reset";

/**
 * POST api/v1/public/apps/password/forgot
 * @param {{ phone?: string, username?: string, email?: string, delivery_method?: "sms" | "voice" }} payload
 * Response: { success, message, data?: { phone_hint, expires_in } }. The
 * reply is 200 even when no account matches (data is then missing).
 */
export async function forgotPassword(payload) {
  const response = await publicAppsClient.post(FORGOT_PASSWORD_ENDPOINT, payload);
  return response.data;
}

/**
 * POST api/v1/public/apps/password/reset
 * @param {{ phone: string, otp: string, new_password: string, confirm_password: string }} payload
 * Uses the same identifier as the forgot step. 400 for a wrong/expired OTP,
 * short password or mismatch; 422 PASSWORD_RESET_UNAVAILABLE when the account
 * has no password login (MPIN only).
 */
export async function resetPassword(payload) {
  const response = await publicAppsClient.post(RESET_PASSWORD_ENDPOINT, payload);
  return response.data;
}
